import { render, staticRenderFns } from "./MultiStepQuizV2Dialog.vue?vue&type=template&id=8bfc43cc&scoped=true&"
import script from "./MultiStepQuizV2Dialog.vue?vue&type=script&lang=js&"
export * from "./MultiStepQuizV2Dialog.vue?vue&type=script&lang=js&"
import style0 from "./MultiStepQuizV2Dialog.vue?vue&type=style&index=0&id=8bfc43cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfc43cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VIcon,VTextField,VTooltip})
